import type { AxiosInstance } from 'axios';
import type { Chat } from './interfaces';

export class ChatReportsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  downloadChartImage = (data: Chat.ExportChartImage.Request): Promise<Chat.ExportChartImage.Response> => {
    return this.authenticatedClient
      .post<Chat.ExportChartImage.Response>(`/chat/export-chart-image`, { ...data })
      .then(response => response.data);
  };

  downloadChartPptx = (data: Chat.ExportChartPptx.Request): Promise<Chat.ExportChartPptx.Response> => {
    return this.authenticatedClient
      .post<Chat.ExportChartPptx.Response>(`/chat/export-chart-pptx`, data)
      .then(response => response.data);
  };

  downloadChartCsv = (data: Chat.ExportChartCsv.Request): Promise<Chat.ExportChartCsv.Response> => {
    return this.authenticatedClient
      .post<Chat.ExportChartCsv.Response>(`/chat/export-chart-csv`, data)
      .then(response => response.data);
  };
}